import { useCallback, useEffect, useState } from 'react';
import { getMetaWindow, type MetaReplyChannel, type MetaWindow } from '../../services/MetaMessagesService';

export interface MetaWindowState {
  window: MetaWindow | null;
  error: string | null;
  reload: () => Promise<void>;
}

/** Estado da janela da Meta do cliente. Recarrega quando a conversa muda ou chega mensagem nova (<c>refreshKey</c>). */
export function useMetaWindow(
  sectorId: number | null,
  contactId: number | null,
  channel: MetaReplyChannel,
  refreshKey: unknown,
): MetaWindowState {
  const [window, setWindow] = useState<MetaWindow | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    if (!sectorId || !contactId) return;
    let alive = true;
    getMetaWindow(sectorId, contactId, channel)
      .then((w) => {
        if (!alive) return;
        setWindow(w);
        setError(null);
      })
      .catch((e) => {
        if (!alive) return;
        const message = (e as { response?: { data?: { message?: string } } })?.response?.data?.message;
        setWindow(null);
        setError(message?.trim() || 'Não foi possível ver o prazo da Meta agora.');
      });
    return () => {
      alive = false;
    };
  }, [sectorId, contactId, channel, refreshKey, tick]);

  const reload = useCallback(async () => setTick((t) => t + 1), []);
  return { window, error, reload };
}
